<template>
  <span
    class="diff-badge"
    :style="badgeStyle"
  >
    {{ name }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { difficultyTextColors } from '@/utils/difficultyColor'

const props = defineProps<{
  name: string
  color: string
}>()

const badgeStyle = computed(() => {
  const text = difficultyTextColors(props.color)
  return {
    background: `color-mix(in srgb, ${props.color} 15%, transparent)`,
    '--diff-txt-light': text.light,
    '--diff-txt-dark': text.dark,
  }
})
</script>

<style scoped>
.diff-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  color: var(--diff-txt-light);
}
:global(.dark) .diff-badge {
  color: var(--diff-txt-dark);
}
</style>
